<template>
  <div>
    <q-select
      v-model="model"
      use-input
      input-debounce="0"
      :label="label"
      option-label="id"
      option-value="id"
      :emit-value="emitValue"
      map-options
      :disable="disable"
      hint=""
      :use-chips="multiple"
      :multiple="multiple"
      :loading="devicesLoading"
      clearable="clearable"
      :options="options"
      @filter="filterFn"
      @input="$emit('changed', model)"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section v-if="devices.length == 0" class="text-grey">
            No results
          </q-item-section>
          <q-item-section v-if="devices.length != 0" class="text-grey">
            All devices are currently assigned, no devices available
          </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    props: {
      id: {
        default: null,
      },
      label: {
        type: String,
        default: "Assign Device",
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      disable: {
        type: Boolean,
        default: false,
      },
      filterOrganizationsID: {
        default: null,
      },
      filterApplicationsID: {
        default: null,
      },
      allowOwned: {
        default: false,
      },
      emitValue: {
        default: true,
      },
      clearable: {
        default: false,
      },
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        devices: "devices/list",
        devicesLoading: "devices/listLoading",
      }),
    },
    watch: {
      id: function () {
        this.init();
      },
      devices: function () {
        this.init();
      },
      filterOrganizationsID: function () {
        this.init();
      },
    },
    data: () => ({
      model: null,
      options: [],
    }),
    mounted() {
      this.init();
    },
    methods: {
      init() {
        let devices = this.getDevicesList();

        this.options = devices;
        let idList = null;
        if (this.multiple && this.id) {
          idList = this.id.split(",").map(function (x) {
            return parseInt(x, 10);
          });
        } else {
          idList = this.id;
        }
        this.model = idList;
      },
      filterFn(val, update) {
        let devices = this.getDevicesList();

        if (val === "") {
          update(() => {
            this.options = devices;
          });
          return;
        } else {
          update(() => {
            const needle = val.toLowerCase();
            this.options = devices.filter(
              (v) => v.id.toLowerCase().indexOf(needle) > -1
            );
          });
        }
      },
      getDevicesList() {
        let devices = JSON.parse(JSON.stringify(this.devices));
        if (this.filterOrganizationsID) {
          devices = devices.filter(
            (d) =>
              d.organizations_id == this.filterOrganizationsID &&
              (!d.ownerships_id || !this.allowOwned) &&
              !d.deployments_id
          );
        }
        if (this.filterApplicationsID) {
          devices = devices.filter(
            (d) =>
              d.applications_id == this.filterApplicationsID &&
              (!d.ownerships_id || !this.allowOwned) &&
              !d.deployments_id
          );
        }
        return devices;
      },
    },
  };
</script>
